import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { api, resolveImageUrl } from '../lib/api';
import PassportMap from '../components/PassportMap';
import QrImg from '../components/QrImg';

const LS = 'tv_passport_token';
const lsGet = () => { try { return localStorage.getItem(LS) || ''; } catch (e) { return ''; } };
const lsSet = (v) => { try { if (v) localStorage.setItem(LS, v); else localStorage.removeItem(LS); } catch (e) { /* ignore */ } };
const errOf = (e, fb) => (e && e.response && e.response.data && e.response.data.detail) ? String(e.response.data.detail) : (fb || 'Terjadi kesalahan, coba lagi.');
const img = (u) => (u ? resolveImageUrl(u) : '');
const codeFrom = (raw) => {
  const s = String(raw || '').trim();
  try { const u = new URL(s); const c = u.searchParams.get('c'); if (c) return c; } catch (e) { /* bukan URL */ }
  return s;
};

const CSS = `
@font-face { font-family: 'Akira Expanded'; src: url('/fonts/akira-expanded.otf') format('opentype'); font-display: swap; }
.tvpp { min-height: 100vh; background-color: #ECEAE4; background-image: repeating-linear-gradient(0deg, rgba(17,17,17,.024) 0 1px, transparent 1px 28px), repeating-linear-gradient(90deg, rgba(17,17,17,.024) 0 1px, transparent 1px 28px); color: #111; font-family: 'DM Sans', system-ui, sans-serif; padding-bottom: 92px; }
.tvpp-wrap { max-width: 560px; margin: 0 auto; padding: 18px 16px 24px; }
.tvpp-h { font-family: 'Akira Expanded', 'DM Sans', sans-serif; font-weight: 800; text-transform: uppercase; letter-spacing: -0.01em; line-height: 1.02; }
.tvpp-lbl { display: block; font-family: 'Akira Expanded', 'DM Sans', sans-serif; font-size: 11px; font-weight: 800; letter-spacing: .06em; text-transform: uppercase; margin-bottom: 6px; }
.tvpp-card { background: #fff; border: 2px solid #111; box-shadow: 6px 6px 0 #111; padding: 18px; }
.tvpp-in { width: 100%; background: #fff; border: 1.5px solid #111; border-radius: 0; padding: 12px; font-size: 16px; font-family: inherit; color: #111; outline: none; box-sizing: border-box; }
.tvpp-in:focus { box-shadow: 3px 3px 0 #111; }
.tvpp-btn { display: inline-flex; align-items: center; justify-content: center; gap: 8px; width: 100%; background: #CAFF00; color: #111; border: 2px solid #111; box-shadow: 5px 5px 0 #111; font-family: 'Akira Expanded', 'DM Sans', sans-serif; font-weight: 800; font-size: 14px; letter-spacing: .04em; text-transform: uppercase; padding: 15px 18px; cursor: pointer; transition: transform .12s, box-shadow .12s; }
.tvpp-btn:active { transform: translate(2px,2px); box-shadow: 2px 2px 0 #111; }
.tvpp-btn:disabled { opacity: .5; cursor: not-allowed; }
.tvpp-btn.ghost { background: #fff; font-size: 11px; padding: 10px 12px; box-shadow: 3px 3px 0 #111; width: auto; }
.tvpp-note { border: 2px solid #111; background: #FFF6CC; padding: 12px 14px; font-size: 14px; line-height: 1.55; }
.tvpp-ok { border: 2px solid #111; background: #DDFBC8; padding: 12px 14px; font-size: 14px; line-height: 1.55; }
.tvpp-bad { border: 2px solid #111; background: #FFD9D2; padding: 12px 14px; font-size: 14px; line-height: 1.55; }
.tvpp-bar { height: 14px; border: 2px solid #111; background: #fff; position: relative; overflow: hidden; }
.tvpp-bar > i { position: absolute; inset: 0 auto 0 0; background: #CAFF00; border-right: 2px solid #111; transition: width .5s; }
.tvpp-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 10px; }
.tvpp-slot { aspect-ratio: 1; border: 2px dashed rgba(17,17,17,.45); border-radius: 50%; display: grid; place-items: center; text-align: center; background: #FAFAF7; position: relative; }
.tvpp-slot.on { border: 2px solid #111; background: #fff; box-shadow: 3px 3px 0 #111; }
.tvpp-slot .n { font-family: 'Akira Expanded', sans-serif; font-weight: 800; font-size: 22px; color: rgba(17,17,17,.3); }
.tvpp-slot img { width: 64%; height: 64%; object-fit: contain; border-radius: 50%; }
.tvpp-slot .ini { width: 64%; height: 64%; border-radius: 50%; background: #111; color: #CAFF00; display: grid; place-items: center; font-family: 'Akira Expanded', sans-serif; font-weight: 800; font-size: 18px; }
.tvpp-slot .bd { position: absolute; bottom: -6px; left: 50%; transform: translateX(-50%); background: #E63329; color: #fff; font-size: 10px; font-weight: 800; padding: 2px 6px; border: 1.5px solid #111; white-space: nowrap; }
.tvpp-cap { font-size: 11px; font-weight: 700; text-align: center; margin-top: 8px; line-height: 1.25; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
.tvpp-nav { position: fixed; left: 0; right: 0; bottom: 0; background: #fff; border-top: 2px solid #111; display: flex; z-index: 20; }
.tvpp-nav button { flex: 1; background: #fff; border: 0; padding: 12px 6px 14px; font-family: 'Akira Expanded', sans-serif; font-weight: 800; font-size: 11px; letter-spacing: .04em; cursor: pointer; }
.tvpp-nav button.on { background: #111; color: #CAFF00; }
.tvpp-row { display: grid; grid-template-columns: 48px minmax(0,1fr) auto; gap: 12px; align-items: center; padding: 10px 0; border-bottom: 1px solid rgba(17,17,17,.12); }
.tvpp-logo { width: 48px; height: 48px; border: 1.5px solid #111; border-radius: 50%; object-fit: contain; background: #fff; }
.tvpp-tag { display: inline-flex; align-items: center; gap: 4px; border: 1.5px solid #111; padding: 3px 8px; font-size: 11px; font-weight: 800; background: #fff; white-space: nowrap; }
.tvpp-tag.ok { background: #CAFF00; }
.tvpp-pop { position: fixed; inset: 0; background: rgba(0,0,0,.6); z-index: 40; display: grid; place-items: center; padding: 20px; }
.tvpp-pop .tvpp-card { width: 100%; max-width: 380px; text-align: center; animation: tvppIn .35s cubic-bezier(.2,1.4,.4,1); }
@keyframes tvppIn { from { transform: scale(.6) rotate(-6deg); opacity: 0; } to { transform: none; opacity: 1; } }
.tvpp-code { font-family: 'Akira Expanded', sans-serif; font-weight: 800; font-size: 34px; letter-spacing: .08em; border: 2px dashed #111; padding: 14px 8px; background: #fff; }
.tvpp-cam { position: relative; border: 2px solid #111; background: #000; aspect-ratio: 1; overflow: hidden; }
.tvpp-cam video { width: 100%; height: 100%; object-fit: cover; }
.tvpp-seg { display: grid; grid-template-columns: 1fr 1fr; border: 2px solid #111; background: #fff; margin-bottom: 14px; }
.tvpp-seg button { border: 0; background: #fff; padding: 12px; font-family: 'Akira Expanded', sans-serif; font-weight: 800; font-size: 12px; letter-spacing: .04em; cursor: pointer; color: #111; }
.tvpp-seg button.on { background: #111; color: #CAFF00; }
.tvpp-link { background: none; border: 0; padding: 0; font-size: 13px; text-decoration: underline; cursor: pointer; color: #111; font-family: inherit; }
.tvpp-qr { background: #fff; border: 2px solid #111; padding: 10px; display: inline-block; }
@keyframes tvppGlow { 0%,100% { box-shadow: 6px 6px 0 #111; } 50% { box-shadow: 6px 6px 0 #111, 0 0 0 6px rgba(202,255,0,.55); } }
.tvpp-cam .fr { position: absolute; inset: 16%; border: 3px solid #CAFF00; box-shadow: 0 0 0 999px rgba(0,0,0,.35); }
`;

function Ini({ name }) {
  const t = String(name || '?').trim().split(/\s+/).map((w) => w[0]).join('').slice(0, 2).toUpperCase();
  return <div className="ini">{t || '?'}</div>;
}

function Scanner({ onCode, onClose }) {
  const vref = useRef(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    let stream = null; let stop = false; let det = null;
    (async () => {
      try {
        if (!('BarcodeDetector' in window)) { setErr('nosupport'); return; }
        det = new window.BarcodeDetector({ formats: ['qr_code'] });
        stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' }, audio: false });
        if (stop) return;
        const v = vref.current; v.srcObject = stream; await v.play();
        const tick = async () => {
          if (stop) return;
          try {
            const r = await det.detect(v);
            if (r && r[0] && r[0].rawValue) { stop = true; onCode(r[0].rawValue); return; }
          } catch (e) { /* frame belum siap */ }
          setTimeout(tick, 250);
        };
        tick();
      } catch (e) { setErr('denied'); }
    })();
    return () => { stop = true; if (stream) stream.getTracks().forEach((t) => t.stop()); };
  }, [onCode]);
  return (
    <div className="tvpp-pop" onClick={onClose}>
      <div className="tvpp-card" onClick={(e) => e.stopPropagation()} style={{ textAlign: 'left' }}>
        <div className="tvpp-h" style={{ fontSize: 18, marginBottom: 12 }}>Scan QR booth</div>
        {err ? (
          <div className="tvpp-note">
            <b>Pakai kamera HP kamu langsung.</b> Buka aplikasi Kamera, arahkan ke QR di booth, lalu ketuk link yang muncul. Stamp otomatis masuk ke paspor ini.
            {err === 'denied' && <div style={{ marginTop: 8, fontSize: 12 }}>(Izin kamera di browser ditolak atau tidak tersedia.)</div>}
          </div>
        ) : (
          <div className="tvpp-cam"><video ref={vref} playsInline muted /><div className="fr" /></div>
        )}
        <p style={{ fontSize: 13, marginTop: 12, lineHeight: 1.5 }}>Sudah post IG Story tag <b>@talesverse</b> + creator? Tunjukkan story ke penjaga booth, lalu minta mereka menampilkan QR.</p>
        <button type="button" className="tvpp-btn ghost" style={{ marginTop: 12, width: '100%' }} onClick={onClose}>Tutup</button>
      </div>
    </div>
  );
}

export default function PassportPage() {
  const [token, setToken] = useState(lsGet());
  const [info, setInfo] = useState(null);
  const [pp, setPp] = useState(null);
  const [tab, setTab] = useState('paspor');
  const [form, setForm] = useState({ name: '', email: '', phone: '', ig: '' });
  const [mode, setMode] = useState('register');
  const [lform, setLform] = useState({ email: '', password: '' });
  const [gacha, setGacha] = useState(null);
  const prevRed = useRef(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const [pop, setPop] = useState(null);
  const [scan, setScan] = useState(false);
  const [q, setQ] = useState('');
  const [map, setMap] = useState(null);
  const [focusTid, setFocusTid] = useState('');
  const [pending, setPending] = useState(() => { try { return new URLSearchParams(window.location.search).get('c') || ''; } catch (e) { return ''; } });

  useEffect(() => {
    document.title = 'Memories Passport | Talesverse';
    if (!document.getElementById('tvp-dmsans')) {
      const l = document.createElement('link'); l.id = 'tvp-dmsans'; l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap';
      document.head.appendChild(l);
    }
    if (pending) { try { window.history.replaceState(null, '', window.location.pathname); } catch (e) { /* ignore */ } }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const loadInfo = useCallback(() => api.get('/passport/info').then(({ data }) => setInfo(data)).catch(() => setInfo({ config: { enabled: false }, tenants: [] })), []);
  const loadMe = useCallback(async (tk) => {
    if (!tk) { setPp(null); return; }
    try { const { data } = await api.get('/passport/me', { headers: { 'X-Passport': tk } }); setPp(data.passport); }
    catch (e) { if (e && e.response && e.response.status === 401) { lsSet(''); setToken(''); setPp(null); } }
  }, []);
  useEffect(() => { loadInfo(); }, [loadInfo]);
  useEffect(() => { if (token && !map) api.get('/passport/map').then(({ data }) => setMap(data)).catch(() => setMap({ layout: {}, booths: {} })); }, [token, map]);
  const mapTids = useMemo(() => new Set(Object.values((map && map.booths) || {})), [map]);
  useEffect(() => { loadMe(token); }, [token, loadMe]);

  const doScan = useCallback(async (raw) => {
    const code = codeFrom(raw);
    if (!code) return;
    setScan(false); setMsg(null);
    try {
      const { data } = await api.post('/passport/scan', { code }, { headers: { 'X-Passport': lsGet() } });
      setPp(data.passport);
      setPop({ stamp: data.stamp, full: data.passport.full && data.stamp.kind === 't' && data.passport.count === data.passport.required });
      setTab('paspor');
    } catch (e) { setMsg({ ok: false, t: errOf(e) }); window.scrollTo({ top: 0, behavior: 'smooth' }); }
  }, []);

  useEffect(() => {
    if (pending && token && pp) { const c = pending; setPending(''); doScan(c); }
  }, [pending, token, pp, doScan]);

  const register = async (e) => {
    e.preventDefault(); setBusy(true); setMsg(null);
    try {
      const { data } = await api.post('/passport/register', { ...form, origin: window.location.origin });
      if (data.mailed) {
        setLform({ email: form.email, password: '' }); setMode('login');
        setMsg({ ok: true, t: `Akun dibuat! Password dikirim ke ${data.email}. Cek inbox atau folder spam, lalu masuk di bawah.` });
      } else {
        lsSet(data.token); setToken(data.token); setPp(data.passport);
        setMsg({ ok: true, t: `Akun dibuat. Simpan password kamu: ${data.password}` });
      }
    } catch (e2) { setMsg({ ok: false, t: errOf(e2) }); }
    finally { setBusy(false); }
  };
  const login = async (e) => {
    e.preventDefault(); setBusy(true); setMsg(null);
    try {
      const { data } = await api.post('/passport/login', lform);
      lsSet(data.token); setToken(data.token); setPp(data.passport);
    } catch (e2) { setMsg({ ok: false, t: errOf(e2) }); }
    finally { setBusy(false); }
  };
  const forgot = async (e) => {
    e.preventDefault(); setBusy(true); setMsg(null);
    try {
      const { data } = await api.post('/passport/forgot', { email: lform.email, origin: window.location.origin });
      setMode('login'); setMsg({ ok: true, t: data.detail });
    } catch (e2) { setMsg({ ok: false, t: errOf(e2) }); }
    finally { setBusy(false); }
  };
  useEffect(() => {
    if (!pp) { prevRed.current = null; return undefined; }
    const red = pp.redeemed ? pp.redeemed.reward_name : '';
    if (prevRed.current === '' && red) setGacha(red);
    prevRed.current = red;
    if (!pp.full || pp.redeemed) return undefined;
    const iv = setInterval(() => loadMe(lsGet()), 4000);
    return () => clearInterval(iv);
  }, [pp, loadMe]);
  const logout = () => { if (!window.confirm('Keluar dari paspor ini di HP ini? Stamp tetap tersimpan, masuk lagi pakai email dan password kamu.')) return; lsSet(''); setToken(''); setPp(null); };

  const cfg = (info && info.config) || {};
  const tenants = (info && info.tenants) || [];
  const stampKeys = useMemo(() => new Set(((pp && pp.stamps) || []).map((s) => s.key)), [pp]);
  const tStamps = ((pp && pp.stamps) || []).filter((s) => s.kind === 't');
  const sStamps = ((pp && pp.stamps) || []).filter((s) => s.kind === 's');
  const req = (pp && pp.required) || cfg.required || 6;
  const shown = useMemo(() => {
    const s = q.trim().toLowerCase();
    return tenants.filter((t) => !s || [t.name, t.booth, t.category, t.instagram].some((v) => String(v || '').toLowerCase().includes(s)));
  }, [tenants, q]);

  const head = (
    <>
      <div style={{ fontFamily: "'Akira Expanded', sans-serif", fontWeight: 800, fontSize: 11, letterSpacing: '.08em' }}>TALESVERSE MEMORIES MARKET | 12-13 DES 2026</div>
      <h1 className="tvpp-h" style={{ fontSize: 'clamp(28px, 9vw, 40px)', margin: '8px 0 2px' }}>Memories<br />Passport</h1>
    </>
  );

  if (!info) return <div className="tvpp"><style>{CSS}</style><div className="tvpp-wrap" style={{ textAlign: 'center', paddingTop: 120 }}>Memuat paspor...</div></div>;

  if (!token || !pp) {
    return (
      <div className="tvpp" data-testid="passport-page"><style>{CSS}</style>
        <div className="tvpp-wrap">
          {head}
          <p style={{ fontSize: 15, lineHeight: 1.55, margin: '10px 0 18px' }}>Kumpulkan <b>{cfg.required || 6} stamp</b> dari booth creator, tukar paspor penuh dengan hadiah di Info Booth.</p>
          {pending && <div className="tvpp-note" style={{ marginBottom: 14 }}>Masuk atau daftar dulu sebentar, stamp dari QR yang barusan kamu scan langsung masuk setelah ini.</div>}
          {mode !== 'forgot' && (
            <div className="tvpp-seg" role="tablist">
              <button type="button" className={mode === 'login' ? 'on' : ''} onClick={() => { setMode('login'); setMsg(null); }} data-testid="passport-mode-login">Masuk</button>
              <button type="button" className={mode === 'register' ? 'on' : ''} onClick={() => { setMode('register'); setMsg(null); }} data-testid="passport-mode-register">Daftar</button>
            </div>
          )}
          {msg && <div className={msg.ok ? 'tvpp-ok' : 'tvpp-bad'} style={{ marginBottom: 14 }} data-testid="passport-msg">{msg.t}</div>}
          {mode === 'login' && (
            <form className="tvpp-card" onSubmit={login} style={{ display: 'grid', gap: 14 }} data-testid="passport-login">
              <label><span className="tvpp-lbl">Email</span><input className="tvpp-in" type="email" value={lform.email} onChange={(e) => setLform({ ...lform, email: e.target.value })} placeholder="nama@email.com" autoCapitalize="none" autoComplete="email" required /></label>
              <label><span className="tvpp-lbl">Password</span><input className="tvpp-in" type="password" value={lform.password} onChange={(e) => setLform({ ...lform, password: e.target.value })} placeholder="Password dari email" autoCapitalize="none" autoComplete="current-password" required /></label>
              <button className="tvpp-btn" disabled={busy}>{busy ? 'Memproses...' : 'Masuk ke paspor'}</button>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap', fontSize: 13 }}>
                <button type="button" className="tvpp-link" onClick={() => { setMode('forgot'); setMsg(null); }} data-testid="passport-forgot-link">Lupa password?</button>
                <span>Belum punya akun? <button type="button" className="tvpp-link" onClick={() => { setMode('register'); setMsg(null); }}><b>Daftar</b></button></span>
              </div>
            </form>
          )}
          {mode === 'register' && (
            <form className="tvpp-card" onSubmit={register} style={{ display: 'grid', gap: 14 }} data-testid="passport-register">
              <label><span className="tvpp-lbl">Nama panggilan</span><input className="tvpp-in" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nama kamu" maxLength={60} required /></label>
              <label><span className="tvpp-lbl">Email</span><input className="tvpp-in" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="nama@email.com" autoCapitalize="none" autoComplete="email" required /></label>
              <label><span className="tvpp-lbl">No. WhatsApp</span><input className="tvpp-in" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="08xx xxxx xxxx" inputMode="tel" required /></label>
              <label><span className="tvpp-lbl">Username Instagram</span><input className="tvpp-in" value={form.ig} onChange={(e) => setForm({ ...form, ig: e.target.value })} placeholder="@username" autoCapitalize="none" /></label>
              <button className="tvpp-btn" disabled={busy}>{busy ? 'Mengirim...' : 'Daftar & kirim password'}</button>
              <div style={{ fontSize: 12, color: '#555', lineHeight: 1.5 }}>Password login dikirim ke email kamu. Satu email dan satu nomor WhatsApp untuk satu paspor.</div>
            </form>
          )}
          {mode === 'forgot' && (
            <form className="tvpp-card" onSubmit={forgot} style={{ display: 'grid', gap: 14 }} data-testid="passport-forgot">
              <span className="tvpp-lbl" style={{ margin: 0 }}>Lupa password</span>
              <p style={{ fontSize: 14, lineHeight: 1.55, margin: 0 }}>Masukkan email yang kamu pakai saat daftar. Kami kirim password baru ke email itu.</p>
              <label><span className="tvpp-lbl">Email</span><input className="tvpp-in" type="email" value={lform.email} onChange={(e) => setLform({ ...lform, email: e.target.value })} placeholder="nama@email.com" autoCapitalize="none" required /></label>
              <button className="tvpp-btn" disabled={busy}>{busy ? 'Mengirim...' : 'Kirim password baru'}</button>
              <button type="button" className="tvpp-link" onClick={() => { setMode('login'); setMsg(null); }}>Kembali ke halaman masuk</button>
            </form>
          )}
          {cfg.rules_text && <div className="tvpp-card" style={{ marginTop: 18 }}><span className="tvpp-lbl">Cara main</span><p style={{ fontSize: 14, lineHeight: 1.6, margin: 0, whiteSpace: 'pre-wrap' }}>{cfg.rules_text}</p></div>}
        </div>
      </div>
    );
  }

  return (
    <div className="tvpp" data-testid="passport-page"><style>{CSS}</style>
      <div className="tvpp-wrap">
        {head}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, margin: '8px 0 14px' }}>
          <div style={{ fontWeight: 700 }}>Halo, {pp.name}{pp.ig ? <span style={{ color: '#666', fontWeight: 500 }}> @{pp.ig}</span> : null}</div>
          <button type="button" onClick={logout} style={{ background: 'none', border: 0, fontSize: 12, textDecoration: 'underline', cursor: 'pointer' }}>Keluar</button>
        </div>
        {!cfg.open && <div className="tvpp-note" style={{ marginBottom: 14 }}>{cfg.closed_reason || 'Memories Passport belum dibuka.'}</div>}
        {msg && <div className={msg.ok ? 'tvpp-ok' : 'tvpp-bad'} style={{ marginBottom: 14 }} data-testid="passport-msg">{msg.t}</div>}

        {tab === 'paspor' && (
          <>
            {pp.won && <div className="tvpp-ok" style={{ marginBottom: 14 }}><b>Selamat! Kamu pemenang undian grand prize.</b> Datang ke Info Booth dan tunjukkan halaman ini.</div>}
            {pp.full && (
              <div className="tvpp-card" style={{ marginBottom: 18, background: pp.redeemed ? '#fff' : '#CAFF00', textAlign: 'center' }} data-testid="passport-full">
                <div className="tvpp-h" style={{ fontSize: 20 }}>{pp.redeemed ? 'Hadiah sudah ditukar' : 'Paspor penuh!'}</div>
                {pp.redeemed ? (
                  <p style={{ margin: '10px 0 0', fontSize: 14 }}>Kamu mendapat <b>{pp.redeemed.reward_name}</b> dari gacha. Terima kasih sudah keliling Talesverse!</p>
                ) : (
                  <>
                    <p style={{ margin: '8px 0 14px', fontSize: 14, lineHeight: 1.5 }}>Datang ke <b>Info Booth</b> dan tunjukkan QR ini ke petugas. Petugas scan, lalu gacha hadiah kamu diputar!</p>
                    <div className="tvpp-qr" data-testid="passport-redeem-qr">{pp.redeem_qr ? <QrImg text={`${window.location.origin}/redeem?r=${encodeURIComponent(pp.redeem_qr)}`} size={220} /> : <div style={{ width: 220, height: 220 }} />}</div>
                    <div style={{ fontFamily: "'Akira Expanded', sans-serif", fontWeight: 800, fontSize: 18, letterSpacing: '.08em', marginTop: 12 }} data-testid="passport-code">TV-{pp.code}</div>
                    <div style={{ fontSize: 11, marginTop: 4 }}>Kode cadangan kalau QR sulit discan</div>
                    {cfg.grand_prize && <p style={{ margin: '12px 0 0', fontSize: 12 }}>{cfg.grand_prize_text}</p>}
                  </>
                )}
              </div>
            )}
            <div className="tvpp-card">
              <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 8 }}>
                <span className="tvpp-lbl" style={{ margin: 0 }}>Stamp creator</span>
                <span className="tvpp-h" style={{ fontSize: 22 }} data-testid="passport-count">{Math.min(pp.count, req)}/{req}</span>
              </div>
              <div className="tvpp-bar"><i style={{ width: `${Math.min(100, (pp.count / req) * 100)}%` }} /></div>
              <div className="tvpp-grid" style={{ marginTop: 18 }}>
                {Array.from({ length: Math.max(req, tStamps.length) }).map((_, i) => {
                  const s = tStamps[i];
                  return (
                    <div key={i}>
                      <div className={`tvpp-slot ${s ? 'on' : ''}`}>
                        {s ? (s.logo ? <img src={img(s.logo)} alt={s.name} /> : <Ini name={s.name} />) : <span className="n">{i + 1}</span>}
                        {s && s.booth && <span className="bd">{s.booth}</span>}
                      </div>
                      <div className="tvpp-cap">{s ? s.name : ' '}</div>
                    </div>
                  );
                })}
              </div>
              {sStamps.length > 0 && (
                <div style={{ marginTop: 16, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  <span className="tvpp-lbl" style={{ width: '100%' }}>Stamp spesial</span>
                  {sStamps.map((s) => <span key={s.key} className="tvpp-tag ok">★ {s.name}</span>)}
                </div>
              )}
              {!pp.full && <p style={{ fontSize: 13, margin: '16px 0 0', lineHeight: 1.5 }}>Kurang <b>{req - pp.count} stamp</b> lagi. Cari booth di tab Peta.</p>}
            </div>
            {cfg.rules_text && <div className="tvpp-card" style={{ marginTop: 18 }}><span className="tvpp-lbl">Cara main</span><p style={{ fontSize: 14, lineHeight: 1.6, margin: 0, whiteSpace: 'pre-wrap' }}>{cfg.rules_text}</p></div>}
          </>
        )}

        {tab === 'peta' && (
          <PassportMap map={map} tenants={tenants} stampKeys={stampKeys} focusTid={focusTid} onFocused={() => setFocusTid('')} onScan={() => { setMsg(null); setScan(true); }} />
        )}

        {tab === 'creator' && (
          <div className="tvpp-card" data-testid="passport-creators">
            <input className="tvpp-in" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari creator, booth, kategori..." />
            <div style={{ fontSize: 12, color: '#555', margin: '10px 0 4px' }}>{tenants.length} creator ikut Memories Passport</div>
            {shown.map((t) => {
              const got = stampKeys.has(`t:${t.id}`);
              return (
                <div key={t.id} className="tvpp-row">
                  {t.logo ? <img className="tvpp-logo" src={img(t.logo)} alt="" /> : <div className="tvpp-logo" style={{ display: 'grid', placeItems: 'center', fontWeight: 800 }}>{String(t.name || '?')[0]}</div>}
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontWeight: 800, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{t.name}</div>
                    <div style={{ fontSize: 12, color: '#555', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {[t.booth && `Booth ${t.booth}`, t.category].filter(Boolean).join(' | ') || '-'}
                      {t.instagram && <> | <a href={`https://instagram.com/${String(t.instagram).replace(/^@/, '').replace(/^https?:\/\/(www\.)?instagram\.com\//, '')}`} target="_blank" rel="noreferrer" style={{ color: '#111' }}>{t.instagram.startsWith('@') ? t.instagram : `@${t.instagram}`}</a></>}
                    </div>
                  </div>
                  <div style={{ display: 'grid', gap: 6, justifyItems: 'end' }}>
                    <span className={`tvpp-tag ${got ? 'ok' : ''}`}>{got ? '✓ Stamp' : 'Belum'}</span>
                    {mapTids.has(t.id) && <button type="button" onClick={() => { setFocusTid(t.id); setTab('peta'); window.scrollTo({ top: 0 }); }} style={{ background: 'none', border: 0, padding: 0, fontSize: 11, fontWeight: 800, textDecoration: 'underline', cursor: 'pointer', color: '#111' }} data-testid={`passport-locate-${t.id}`}>Lihat di peta</button>}
                  </div>
                </div>
              );
            })}
            {!shown.length && <div style={{ padding: '18px 0', fontSize: 14, color: '#555' }}>Belum ada creator yang cocok.</div>}
          </div>
        )}
      </div>

      <div className="tvpp-nav">
        <button type="button" className={tab === 'paspor' ? 'on' : ''} onClick={() => setTab('paspor')} data-testid="passport-tab-paspor">Paspor</button>
        <button type="button" className={tab === 'peta' ? 'on' : ''} onClick={() => setTab('peta')} data-testid="passport-tab-peta">Peta</button>
        <button type="button" onClick={() => { setMsg(null); setScan(true); }} style={{ background: '#CAFF00' }} data-testid="passport-scan">Scan QR</button>
        <button type="button" className={tab === 'creator' ? 'on' : ''} onClick={() => setTab('creator')} data-testid="passport-tab-creator">Creator</button>
      </div>

      {scan && <Scanner onCode={doScan} onClose={() => setScan(false)} />}
      {gacha && (
        <div className="tvpp-pop" onClick={() => setGacha(null)} data-testid="passport-gacha-pop">
          <div className="tvpp-card" onClick={(e) => e.stopPropagation()} style={{ background: '#CAFF00', animation: 'tvppIn .35s cubic-bezier(.2,1.4,.4,1), tvppGlow 1.6s ease-in-out infinite' }}>
            <div className="tvpp-lbl" style={{ marginBottom: 10 }}>Hasil gacha kamu</div>
            <div className="tvpp-h" style={{ fontSize: 28, margin: '6px 0 12px' }}>{gacha}</div>
            <p style={{ fontSize: 14, margin: '0 0 16px', lineHeight: 1.5 }}>Ambil hadiahmu dari petugas Info Booth. Jangan lupa story & tag <b>@talesverse</b>!</p>
            <button type="button" className="tvpp-btn" style={{ background: '#fff' }} onClick={() => setGacha(null)}>Yeay!</button>
          </div>
        </div>
      )}
      {pop && (
        <div className="tvpp-pop" onClick={() => setPop(null)} data-testid="passport-pop">
          <div className="tvpp-card" onClick={(e) => e.stopPropagation()}>
            <div className="tvpp-lbl" style={{ marginBottom: 12 }}>{pop.stamp.kind === 's' ? 'Stamp spesial!' : 'Stamp baru!'}</div>
            <div className="tvpp-slot on" style={{ width: 130, margin: '0 auto' }}>
              {pop.stamp.logo ? <img src={img(pop.stamp.logo)} alt="" /> : <Ini name={pop.stamp.name} />}
              {pop.stamp.booth && <span className="bd">{pop.stamp.booth}</span>}
            </div>
            <div className="tvpp-h" style={{ fontSize: 20, marginTop: 18 }}>{pop.stamp.name}</div>
            <p style={{ fontSize: 14, margin: '10px 0 16px' }}>{pop.full ? 'Paspor kamu penuh! Tunjukkan QR paspor ke petugas Info Booth untuk gacha hadiah.' : `${pp.count}/${req} stamp terkumpul.`} Jangan lupa repost story kamu & tag <b>@talesverse</b>.</p>
            <button type="button" className="tvpp-btn" onClick={() => setPop(null)}>Lanjut</button>
          </div>
        </div>
      )}
    </div>
  );
}
